__turbopack_context__.v({
  "content": "Dialog-module__erR1Nq__content",
  "dialogContentIn": "Dialog-module__erR1Nq__dialogContentIn",
  "dialogContentOut": "Dialog-module__erR1Nq__dialogContentOut",
  "dialogOverlayIn": "Dialog-module__erR1Nq__dialogOverlayIn",
  "dialogOverlayOut": "Dialog-module__erR1Nq__dialogOverlayOut",
  "overlay": "Dialog-module__erR1Nq__overlay",
});
